import useCreatePromoCode from 'components/domain/promoCode/useCreatePromoCode';
import { CreatePromoCodePayload } from 'models/PromoCode';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import useNotify from 'hooks/useNotify';
import { useTranslation } from 'react-i18next';
import useAppUser from 'hooks/useAppUser';
import { AddPromoCodeFormValues } from './addForm/AddForm.schema';

const useAddPromoCodeFormSubmit = () => {
  const navigate = useNavigate();
  const { notifyError } = useNotify();
  const { t } = useTranslation();
  const { agency } = useAppUser();
  const { createPromoCode, isLoading: isCreatingPromoCode } =
    useCreatePromoCode({
      onSuccess: () => {
        navigate('/promo-codes');
      },
      onError: () => {
        notifyError(
          t('pageDiscountCodes.pageAddDiscount.errorCreatingPromoCode'),
        );
      },
    });

  const handleSubmit = async (values: AddPromoCodeFormValues) => {
    const payload: CreatePromoCodePayload = {
      ...values,
      value: Number(values.value),
      validFromDate: `${format(values.validFromDate, 'yyyy-MM-dd')}T00:00:00`,
      validToDate: `${format(values.validToDate, 'yyyy-MM-dd')}T23:59:59`,
      expirationDate: `${format(values.expirationDate, 'yyyy-MM-dd')}T23:59:59`,
      currency: agency!.currency,
    };

    await createPromoCode(payload);
  };

  return {
    handleSubmit,
    isCreatingPromoCode,
  };
};

export default useAddPromoCodeFormSubmit;
